import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { LangText } from '@/components'
import { TEMP_COUPON_STORES } from '@/pages/Coupon/List/couponListInfo'
import { CouponCard } from '@/pages/Coupon/List'

const MAX_VISIBLE_COUPONS = 6

const COUPON_TABS = [
  { id: 'shopping', labelKey: 'home.coupon.tabs.shopping', primaryCategory: '购物' },
  { id: 'food', labelKey: 'home.coupon.tabs.food', primaryCategory: '餐饮美食' },
  { id: 'transport', labelKey: 'home.coupon.tabs.transport', primaryCategory: '交通出行' },
  { id: 'hotel', labelKey: 'home.coupon.tabs.hotel', primaryCategory: '住宿娱乐' },
] as const

type CouponTabId = (typeof COUPON_TABS)[number]['id']

const CouponRecommendations = () => {
  const [activeTab, setActiveTab] = useState<CouponTabId>('shopping')

  const activeCategory = COUPON_TABS.find((tab) => tab.id === activeTab)?.primaryCategory
  const coupons = useMemo(
    () =>
      TEMP_COUPON_STORES.filter((store) => store.primaryCategory.zh_CN === activeCategory).slice(
        0,
        MAX_VISIBLE_COUPONS,
      ),
    [activeCategory],
  )

  return (
    <section className="w-full bg-[#FAFAFA] pb-[76px] pt-[60px]">
      <div className="mx-auto w-[1200px]">
        <div className="flex flex-col items-center">
          <LangText
            lngKey="coupon.recommendations.title"
            className="text-[36px] font-bold leading-[50px] text-[#000000]"
          />
          <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
        </div>

        <div className="mt-[48px] flex items-center justify-between">
          <div className="flex items-center gap-[12px]">
            {COUPON_TABS.map((tab) => {
              const isActive = activeTab === tab.id
              const isDisabled = tab.id !== 'shopping'

              return (
                <button
                  key={tab.id}
                  type="button"
                  disabled={isDisabled}
                  onClick={() => setActiveTab(tab.id)}
                  className={`h-[40px] min-w-[100px] rounded-[8px] px-[18px] text-[16px] transition-colors disabled:cursor-not-allowed ${
                    isActive
                      ? 'border border-primary bg-secondary text-primary'
                      : 'border border-transparent bg-[#F2F2F2] text-[#979797]'
                  }`}
                >
                  <LangText lngKey={tab.labelKey} />
                </button>
              )
            })}
          </div>

          <Link
            to="/coupon-list"
            className="inline-flex h-[40px] items-center rounded-full bg-primary px-[24px] text-[16px] text-white transition-opacity hover:opacity-90"
          >
            <LangText lngKey="common.action.viewAll" />
          </Link>
        </div>

        <div className="mt-[24px] grid grid-cols-3 gap-[24px]">
          {coupons.map((coupon) => (
            <CouponCard key={coupon.id} store={coupon} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default CouponRecommendations
